import { ChartOption, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const xaxisLabels: Array<string> = [];
  for (let i = 0; i < datas.colCount; i++) {
    if (datas.colDimNodes[i][0].total) {
      continue;
    }
    xaxisLabels.push(datas.colDimNodes[i][0].label);
  }

  const yaxisLabels: Array<string> = [];
  for (let i = 0; i < datas.rowCount; i++) {
    if (datas.rowDimNodes[i][0].total) {
      continue;
    }
    yaxisLabels.push(datas.rowDimNodes[i][0].label);
  }

  xaxisLabels.unshift("");
  xaxisLabels.push("");

  yaxisLabels.unshift("");
  yaxisLabels.push("");

  const data1 = [];
  for (var i = 0; i < xaxisLabels.length; i++) {
    for (let j = 0; j < yaxisLabels.length; j++) {
      if (i == 0 || i == xaxisLabels.length - 1) {
        data1.push([i, j, 0]);
      } else if (j == 0 || j == yaxisLabels.length - 1) {
        data1.push([i, j, 0]);
      } else {
        let count = 0;
        if (datas.dataValues[datas.rowColIndexes[j - 1][i - 1]]) {
          count = datas.dataValues[datas.rowColIndexes[j - 1][i - 1]][0];
        }
        data1.push([i, j, count]);
      }
    }
  }
  const data = [data1];

  const scatterSeries = [];
  scatterSeries.push({
    name: "scatter-0",
    type: "scatter",
    legendHoverLink: false,
    symbol: i > 0 ? "none" : "",
    symbolSize: 0.01,
    data: data[i],
  });

  const option: any = {
    tooltip: {
      position: "right",
      trigger: "item",
      formatter: function (params: any) {
        return params.seriesName.replace(/PATBIS/g, "<br/>");
      },
    },
    grid: {
      top: "24%",
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: xaxisLabels,
      position: "top",
      boundaryGap: false,
      splitLine: {
        show: true,
        interval: function (index: number, value: any) {
          return index > 0 && index < xaxisLabels.length - 1;
        },
        lineStyle: {
          color: "#999",
          type: "solid",
        },
      },
      axisLine: {
        show: false,
      },
      axisLabel: {
        rotate: -30,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      data: yaxisLabels,
      boundaryGap: false,
      splitLine: {
        show: true,
        interval: function (index: number, value: any) {
          return index > 0 && index < yaxisLabels.length - 1;
        },
        lineStyle: {
          color: "#999",
          type: "solid",
        },
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
    series: scatterSeries,
  };

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title,
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.toolbox = {
      show: true,
      feature: {
        saveAsImage: {},
      },
    };
  }

  const refreshChart = function (chart: any, params: any) {
    const series = chart.getOption().series.slice(0, 1);

    let maxData = 0;
    for (var i = 1; i < xaxisLabels.length - 1; i++) {
      for (var j = 1; j < yaxisLabels.length - 1; j++) {
        var idx = i * yaxisLabels.length + j;
        const v = data[0][idx][2];
        if (v > maxData) {
          maxData = v;
        }
      }
    }

    for (var i = 1; i < xaxisLabels.length - 1; i++) {
      for (var j = 1; j < yaxisLabels.length - 1; j++) {
        var idx = i * yaxisLabels.length + j;

        const pieData = [];
        const v = data[0][idx][2];
        pieData.push({ name: definition.measures[0].label, value: v });

        const radius = (v / maxData) * 32;

        series.push({
          type: "pie",
          name:
            definition.rowDims[0].label +
            ": " +
            yaxisLabels[j] +
            "PATBIS" +
            definition.colDims[0].label +
            ": " +
            xaxisLabels[i] +
            "PATBIS" +
            definition.measures[0].label +
            ": " +
            v,
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          radius: radius,
          center: chart.convertToPixel({ seriesIndex: 0 }, [i, j]),
          data: pieData,
        });
      }
    }

    option.animation = true;
    option.series = series;

    chart.setOption(option, true);
  };

  option.events = [
    {
      name: "finished",
      handler: function (chart: any, params: any) {
        chart.off("finished");
        refreshChart(chart, params);
      },
    },
    {
      name: "resized",
      handler: function (chart: any, params: any) {
        refreshChart(chart, params);
      },
    },
  ];

  return option;
}
